import { 
    CRITICAS_PROYECTO,
    AGREGAR_CRITICA,
    VALIDAR_CRITICA,
    ELIMINAR_CRITICA,
    CRITICA_ACTUAL,
    ACTUALIZAR_CRITICA,
    LIMPIAR_CRITICA,
    MOSTRAR_FORMULARIO
} from '../../types';

export default (state, action) => {
    switch(action.type) {
        case CRITICAS_PROYECTO:
            return {
                ...state,
                estadoformulario: true,
                criticaseleccionada: null,
                criticasproyecto: action.payload
            }
        case AGREGAR_CRITICA:
            return {
                ...state,
                criticasproyecto: [action.payload, ...state.criticasproyecto],
                errorcritica: false,
                estadoformulario: true,
                
            }
        case VALIDAR_CRITICA:
            return {
                ...state,
                errorcritica: true,
                
            }
        case ELIMINAR_CRITICA: 
            return {
                ...state,
                criticasproyecto: state.criticasproyecto.filter(critica => critica._id !== action.payload ),
                estadoformulario: true,
            }
        case ACTUALIZAR_CRITICA: 
            return {
                ...state,
                criticasproyecto: state.criticasproyecto.map(critica => critica._id === action.payload._id ? action.payload : critica ),
                
                
            }
        case CRITICA_ACTUAL:
            return {
                ...state,
                criticaseleccionada: action.payload
            }
        case LIMPIAR_CRITICA:
            return {
                ...state,
                criticaseleccionada: null 
            }
        case MOSTRAR_FORMULARIO:
            return {
                ...state,
                estadoformulario: action.payload
            }
        default:
            return state;
    }
}